import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      user {
        id
        email
        roles
        bio
        title
        profilePhoto
      }
      token
      message
      error
      statusCode
    }
  }
`;

export const REGISTER_MUTATION = gql`
  mutation Register($input: RegisterInput!) {
    register(input: $input) {
      user {
        id
        email
        roles
      }
      message
      error
      statusCode
    }
  }
`;

export const UPDATE_PROFILE_MUTATION = gql`
  mutation UpdateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      id
      email
      username
      bio
      location
      title
      skills
      linkedin
      github
      x
      website
      profilePhoto
      coverPhoto
      roles
    }
  }
`;


export const UPDATE_COVER_PHOTO_MUTATION = gql`
  mutation UpdateCoverPhoto($coverPhoto: Upload!) {
    updateCoverPic(coverPhoto: $coverPhoto) {
      id
      username
      coverPhoto
      email
      roles
    }
  }
`;

export const UPDATE_PROFILE_PHOTO_MUTATION = gql`
  mutation UpdateProfilePhoto($profilePhoto: Upload!) {
    updateProfilepic(profilePhoto: $profilePhoto) {
      id
      email
      username
      profilePhoto
      roles
    }
  }
`;

export const VERIFY_EMAIL_MUTATION = gql`
  mutation VerifyEmail($token: String!) {
    verifyEmail(token: $token) {
      success
      message
      statusCode
    }
  }
`;

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation ForgotPassword($input: ForgotPasswordInput!) {
    forgotPassword(input: $input) {
      success
      message
      statusCode
      error
    }
  }
`;

// Add this mutation to your existing mutations file
export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      success
      message
      statusCode
      error
    }
  }
`;